<template>
  <div v-if="ebilletComputed" class="relative full-height scrollable">
    <div v-if="ebilletComputed.contremarque || ebilletComputed.order_contremarque" class="col-12 greener-bg py1 center">
      <span class="caps h7n bold white">contremarque</span>
    </div>

    <div v-else class="col-12 light-blue-bg py1 center">
      <span class="caps h7n bold white">e-billet</span>
    </div>

    <div class="flex flex-wrap flex-auto no-box p2 white-bg">
      <div class="col-12 sm-col-8 flex">
        <div class="col-12">
          <!-- Ticket Name -->
          <div class="col-12">
            <span class="bold block h4n">{{ ebilletComputed.product_name }}</span>
            <span class="h5n">{{ ebilletComputed.horanet_product_name }}</span>
          </div>

          <div class="col-12 py3">
            <div class="inline-block mr3">
              <span class="caps block dark-blue h7n">Participant</span>
              <h3 class="my0 h6n regular"><i class="icon icon-profile mr1"></i>{{ ebilletComputed.customer.firstname }} {{ ebilletComputed.customer.lastname }}</h3>
            </div>

            <div v-if="ebilletComputed.endDate" class="inline-block mr3">
              <span class="caps dark-blue block mt1 h7n">Date de fin de validité:</span>
              <div class="inline-block mr1 mb1 h6n">
                <i class="icon icon-date-check-icon"></i>
                {{ ebilletComputed.endDate }}
              </div>
            </div>

            <div v-if="ebilletComputed.showSession" class="inline-block">
              <span class="caps dark-blue block mt1 h7n">séance:</span>
              <div class="inline-block mb1 h6n">
                <i class="icon icon-clock"></i>
                {{ ebilletComputed.session_end_date }} {{ ebilletComputed.startTime }} - {{ ebilletComputed.endTime }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 sm-col-4 flex flex-column justify-between">
        <!-- RemainingSessions -->
        <div class="col-12 flex justify-center sm-justify-end">
          <h3 v-if="!ebilletComputed.unlimited_usage && ebilletComputed.remainingQuantity" class="cond bold h5n my0">
            {{ ebilletComputed.remainingQuantity }}
            <span v-if="ebilletComputed.remainingQuantity == 1"> session restante</span>
            <span v-else> sessions restantes</span>
          </h3>
        </div>

        <!-- QRCODE -->
        <div class="col-12 flex justify-center sm-justify-end">
          <div class="inline-block qrcode no-box flex flex-column items-center">
            <div v-if="ebilletComputed.qrcodeSvg && !ebilletComputed.order_contremarque && !ebilletComputed.order_sans_support" class="pointer" style="width: 100px" v-html="ebilletComputed.qrcodeSvg"></div>
            <div v-else-if="ebilletComputed.order_contremarque" class="pointer grey-bg p1">Pour activer votre e-billet, veuillez vous rendre à l’accueil du centre.</div>
            <span v-if="!ebilletComputed.order_sans_support" class="h5n my1">{{ ebilletComputed.qrcode }}</span>
          </div>
        </div>
      </div>

      <div v-if="ebilletComputed.options && ebilletComputed.options.length" class="col-12">
        <div class="col-12">
          <h3 class="cond h5n mt0 gray caps">options</h3>
        </div>
        <div v-for="opt in ebilletComputed.options" :key="opt">
          <div class="border-top flex flex-wrap col-12 py2">
            <div class="flex-auto mb2">
              <span class="bold block h6n">{{ opt.product_name }}</span>
            </div>

            <div v-if="opt.qrcode[0] && opt.qrcode" class="col-12 flex justify-center sm-justify-end">
              <div class="inline-block qrcode no-box flex flex-column items-center">
                <div v-if="opt.qrcodeSvg && !opt.order_contremarque && !opt.order_sans_support" style="width: 100px" v-html="opt.qrcodeSvg"></div>
                <div v-else-if="opt.order_contremarque" class="pointer grey-bg p1">Pour activer votre e-billet, veuillez vous rendre à l’accueil du centre.</div>
                <span v-if="!opt.order_sans_support" class="h5n my1">{{ opt.qrcode }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { inject, computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export default {
  setup () {
    const route = useRoute();
    const router = useRouter();
    const showQrCode = ref(false);
    const qrCodeToShow = ref(null);
    const ebillets = inject('ebillets');
    const ebilletComputed = computed(() => ebillets.value.find(ebillet => ebillet.qrcode === route.params.qrcode));

    return {
      ebilletComputed,
      router,
      showQrCode,
      qrCodeToShow
    };
  }
};
</script>
